<template>
  <div
    :data-sku="sku"
    class="product-card-vertical flex flex-col items-center justify-center"
  >
    <div
      class="flex w-full gap-4"
    >
      <ProductCardVerticalImage
        :link="link"
        :image="image"
        :title="title"
        :is-clickable="isProductLinkClickable"
      />
      <div class="flex-grow flex flex-col justify-between gap-2">
        <div class="flex flex-col gap-2">
          <ProductCardVerticalTitle
            :link="link"
            :title="title"
            :is-clickable="isProductLinkClickable"
          />
          <EnergyRating
            v-if="energyRating"
            :energy-rating="energyRating"
            :size="ENERGY_RATING_SIZE.SMALL"
            :wrap="true"
          />
        </div>
        <div class="flex justify-between items-center flex-wrap">
          <div
            v-if="!readOnly"
            class="flex justify-between gap-5"
          >
            <button
              class="text-lg flex justify-end items-center"
              data-testid="remove-from-cart__button"
              :aria-label="$t('Remove')"
              @click="$emit('clickRemove')"
            >
              <span class="iconify fa-pro-light--trash" />
            </button>
            <QuantitySelector
              :qty="qty"
              :stock="stock"
              :disabled="false"
              :has-controls="true"
              :mode="'smallButtons'"
              :sku="sku"
              :triggered-in="triggeredIn"
              :align-left="true"
              :name="`${sku}-product-card-quantity-selector`"
              @input="$emit('inputQuantity', $event)"
            />
          </div>
          <ProductCardQuantity
            v-else
            :qty="qty"
          />
          <ProductPricing
            :full-product-price="fullProductPrice"
            :discounted-price="discountedPrice"
            :should-display-discount="shouldDisplayDiscount"
            :size="PRODUCT_PRICING_SIZE.SMALL"
            :is-vertical-price="true"
            :is-price-centered="false"
            class="flex-row-reverse justify-end"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';
import { ENERGY_RATING_SIZE } from '~~/constants/energyRating';
import { PRODUCT_PRICING_SIZE } from '~~/constants/productCardPricing';

export default defineComponent({
  name: 'ProductCardVerticalInner',

  props: {
    title: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    qty: {
      type: Number,
      required: true,
    },
    stock: {
      type: Number,
      default: 0,
    },
    fullProductPrice: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    discountedPrice: {
      type: Number as PropType<Maybe<number>>,
      default: null,
    },
    image: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    unitPrice: {
      type: Number,
      required: true,
    },
    shouldDisplayDiscount: {
      type: Boolean,
      default: false,
    },
    sku: {
      type: String,
      required: true,
    },
    triggeredIn: {
      type: String,
      default: '',
    },
    energyRating: {
      type: Object as PropType<Maybe<EnergyRatingDetails>>,
      default: (): Maybe<EnergyRatingDetails> => null,
    },
  },
  emits: ['clickRemove', 'inputQuantity'],
  setup() {

    const { isOnPaymentPage } = useIsPage();
    const isProductLinkClickable = computed(() => !isOnPaymentPage.value);

    return {
      LINK_TYPE,
      ENERGY_RATING_SIZE,
      PRODUCT_PRICING_SIZE,
      isProductLinkClickable,
    };

  },
});

</script>
